module.exports = __webpack_public_path__ + "static/media/calendarIcon.c06445b5.svg";